
import { Component, Prop, Vue } from "vue-property-decorator";
import { createIdFromLabel } from "./utils";
import FormLabel from "./FormLabel.vue";
import FormFeedback from "./FormFeedback.vue";
import { randomString } from "@gsx/common";

@Component({
    components: { FormFeedback, FormLabel },
    inheritAttrs: false,
})
export default class FormTextarea extends Vue {
    @Prop() label!: string;
    @Prop() value!: string;
    @Prop({ default: false }) required!: boolean;
    @Prop() help?: string;
    @Prop() error?: string;

    get id(): string {
        return this.label ? createIdFromLabel(this.label) : randomString();
    }
}
